// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2UAGI","resendInfoText":"OnGoingPaymentBox_resendInfoText__2AKpi"};